import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
	Route,
	Redirect,
	Switch,
	withRouter,
} from 'react-router-dom'
import Async from 'react-code-splitting'

import generalActions from 'redux/actions/generalActions'
import CenterInformationsController from '../controllers/center_informations_controller'
import TopInformationsController from '../controllers/top_informations_controller'
import AlertsController from '../controllers/alerts_controller'
import LoadingLayer from '../controllers/loading_layer'
import platform from 'helpers/platform'
import storeURLParametersToCookie from 'helpers/storeURLParametersToCookie'
import originRouteTypes from 'helpers/enums/store/originRouteTypes'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import { facebookSdk, googleSdk, gtmSdk, facebookPixelSdk, googleApiInitializer, awsSdk, cseLibrary } from '../helpers/social'
import { chartJS } from '../helpers/visualizations'
import mixpanel from '../helpers/mixpanel'
import chameleon from '../helpers/chameleon'
import canny from '../helpers/canny'

// chunk unlogged
import SignUpBase from 'views/signup/signup_base'
import LogInTeacher from 'views/login/teacher/login_main_unified'
import ForgotPassword from 'views/login/forgot_password/login_forgot_password'
import NewPassword from 'views/login/new_password/login_new_password'
import VerifyAccount from 'views/login/verify_account/login_verify_account'
import CookiesNotSupported from 'routes/cookies_not_supported/route'
import GoogleSlidesAddOnNotSupportedRoute from 'routes/addon_not_supported/google_slides_addon_not_supported_route'
import MatchingPairsScreenshot from 'routes/screenshot/matching_pairs/screenshot_route'
import ConfirmsController from 'controllers/confirms_controller'
import OverlaysController from 'controllers/overlays_controller'
import ModalsController from 'controllers/modals_controller'
import ExternalActivityRoute from 'routes/external_activity/route'
import IntercomIO from 'containers/intercom/container'

// chunk logged
const MyActivitiesRoute = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/my_activities/route')} componentProps={props}/>
const BindersBase = props => <Async load={import(/* webpackChunkName: "logged" */ 'views/binders/binders_base')} componentProps={props}/>
const DrawItCreationToolRoute = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/creation_tool/draw_it/route')} componentProps={props}/>
const AccountBase = props => <Async load={import(/* webpackChunkName: "logged" */ 'views/my_account/my_account_base')} componentProps={props}/>
const Onboarding = props => <Async load={import(/* webpackChunkName: "logged" */ 'views/onboarding/onboarding_base')} componentProps={props}/>
const LibrariesBase = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/private_library/teacher_private_library/route')} componentProps={props}/>
const QuizCreationToolRoute = props => <Async load={import(/* webpackChunkName: "logged" */ 'views/quiz/quiz_base')} componentProps={props}/>
const QuizScreenshot = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/screenshot/quiz/screenshot_route')} componentProps={props}/>
const PollCreationToolRoute = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/creation_tool/poll/route')} componentProps={props}/>
const PollScreenshot = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/screenshot/poll/screenshot_route')} componentProps={props}/>
const OEQCreationToolRoute = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/creation_tool/oeq/route')} componentProps={props}/>
const OEQScreenshot = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/screenshot/oeq/screenshot_route')} componentProps={props}/>
const MyLibraryRoute = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/my_library/route')} componentProps={props}/>
const MyLibraryPreviewRoute = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/my_library/preview/route')} componentProps={props}/>
const StoreBase = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/store/store_base_route')} componentProps={props}/>
const MatchingPairsCreationTool = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/creation_tool/matching_pairs/creation_tool_route')} componentProps={props}/>
const DesmosCreationToolRoute = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/creation_tool/desmos/route')} componentProps={props}/>
const DMStorageExperimentReferContactNotification = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/dm_storage_experiment/refer_contact_notification/route')} componentProps={props}/>
const ShareTeachers = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/school_trial/share_teachers/route')} componentProps={props}/>
const ReferContactNotification = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/school_trial/refer_contact_notification/route')} componentProps={props}/>
const LtiDisplayRoute = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/lti/display/route')} componentProps={props}/>
const GameCreationToolRoute = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/creation_tool/game/route')} componentProps={props}/>
const GameScreenshotRoute = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/screenshot/game/screenshot_route')} componentProps={props}/>
const FlocabularyCreationToolRoute = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/creation_tool/flocabulary/route')} componentProps={props}/>
const FlocabularyScreenshot = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/screenshot/flocabulary/screenshot_route')} componentProps={props}/>
const DeviceNotSupported = props => <Async load={import(/* webpackChunkName: "logged" */ 'views/device/device_not_supported')} componentProps={props}/>
const InteractiveVideoCreationToolRoutes = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/creation_tool/interactive_video/create/route')} componentProps={props}/>
const InteractiveVideoSelectRoute = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/creation_tool/interactive_video/select/route')} componentProps={props}/>
const InteractiveVideoScreenshot = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/screenshot/interactive_video/screenshot_route')} componentProps={props}/>
const FlipgridCreationToolRoute = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/creation_tool/flipgrid/route')} componentProps={props}/>
const VideoCreationToolRoutes = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/creation_tool/video/create/route')} componentProps={props}/>
const TermsAndConditionsRoute = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/terms_and_conditions/route')} componentProps={props}/>

// chunk extra
const NotFound = props => <Async load={import(/* webpackChunkName: "extra" */ 'views/file_not_found/file_not_found')} componentProps={props}/>
const Playground = props => <Async load={import(/* webpackChunkName: "extra" */ 'views/playground/playground')} componentProps={props}/>

// chunk admin
const AdminOnboarding = props => <Async load={import(/* webpackChunkName: "admin" */ 'views/admin_onboarding/admin_onboarding_base')} componentProps={props}/>
const AdminBase = props => <Async load={import(/* webpackChunkName: "admin" */ 'views/admin/admin_base')} componentProps={props}/>

// chunk storefront
const StoreBaseNewRoute = props => <Async
	load={import(/* webpackChunkName: "storefront" */ 'routes/store/base/route')}
	componentProps={{...props, originRouteType: originRouteTypes.NEW_STORE }}
/>

// chunk session
const FlocabularySessionRoute = props => <Async load={import(/* webpackChunkName: "session" */ 'routes/session/flocabulary/route')} componentProps={props}/>
const InteractiveVideoSessionRoute = props => <Async load={import(/* webpackChunkName: "session" */ 'routes/session/interactive_video/route')} componentProps={props}/>
const InteractiveVideoPreviewRoute = props => <Async load={import(/* webpackChunkName: "session" */ 'routes/preview/interactive_video/route')} componentProps={props}/>
const FillInTheBlanksSessionRoute = props => <Async load={import(/* webpackChunkName: "session" */ 'routes/session/fill_in_the_blanks/route')} componentProps={props}/>

// chunk storefront
const StoreBaseOldRoute = props => <Async
	load={import(/* webpackChunkName: "storefront" */ 'routes/store/base/route')}
	componentProps={{...props, originRouteType: originRouteTypes.OLD_STORE }}
/>
const StoreFrontBase = props => <Async load={import(/* webpackChunkName: "storefront" */ 'routes/public_library/public_library_base_route')} componentProps={props}/>

// chunk google slides
const GoogleSlidesRoutes = props => <Async load={import(/* webpackChunkName: "googleslides" */ 'routes/google_slides/routes')} componentProps={props}/>

// chunk standalone
const OEQStandaloneRoute = props => <Async load={import(/* webpackChunkName: "standalone" */ 'routes/standalone/oeq/route')} componentProps={props}/>
const DrawItStandaloneRoute = props => <Async load={import(/* webpackChunkName: "standalone" */ 'routes/standalone/draw_it/route')} componentProps={props}/>
const QuizStandaloneRoute = props => <Async load={import(/* webpackChunkName: "standalone" */ 'routes/standalone/quiz/route')} componentProps={props}/>
const PollStandaloneRoute = props => <Async load={import(/* webpackChunkName: "standalone" */ 'routes/standalone/poll/route')} componentProps={props}/>
const GameStandaloneRoute = props => <Async load={import(/* webpackChunkName: "standalone" */ 'routes/standalone/game/route')} componentProps={props}/>
const MatchingPairsStandalone = props => <Async load={import(/* webpackChunkName: "standalone" */ 'routes/standalone/matching_pairs/route')} componentProps={props}/>
const FlocabularyCreationToolStandaloneRoute = props => <Async load={import(/* webpackChunkName: "standalone" */ 'routes/standalone/flocabulary/creation_tool/route')} componentProps={props}/>
const DesmosCreationToolStandaloneRoute = props => <Async load={import(/* webpackChunkName: "standalone" */ 'routes/standalone/desmos/creation_tool/route')} componentProps={props}/>
const FlipgridStandaloneRoute = props => <Async load={import(/* webpackChunkName: "standalone" */ 'routes/standalone/flipgrid/route')} componentProps={props}/>
const VideoStandaloneRoute = props => <Async load={import(/* webpackChunkName: "standalone" */ 'routes/standalone/video/route')} componentProps={props}/>

// chunk onboarding activity
const OnboardingActivityBase = props => <Async load={import(/* webpackChunkName: "onboarding_activity" */ 'routes/onboarding/routes')} componentProps={props}/>

// chunk user school profile
const UserSchoolProfileRoute = props => <Async load={import(/* webpackChunkName: "user_school_profile" */ 'routes/user_school_profile/route')} componentProps={props}/>

// chunk groups
const ConnectorRoutes = props => <Async load={import(/* webpackChunkName: "connectors" */ 'routes/connectors/connector_routes')} componentProps={props}/>
const QuickLaunchRoutes = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/quick_launch/route')} componentProps={props}/>
const SSOSuccessRoute = props => <Async load={import(/* webpackChunkName: "logged" */ 'routes/sso_success/route')} componentProps={props}/>

// chunk session preview
const SessionPreviewRoute = props => <Async load={import(/* webpackChunkName: "session_preview" */ 'routes/session_preview/route')} componentProps={props}/>

// chunk unlogged
const StudentJoinRoute = props => <Async load={import(/* webpackChunkName: "unlogged" */ 'routes/student_join/route')} componentProps={props}/>

const disabledFacebookLocations = ['/student', '/student/']

class App extends Component {

	constructor(props) {
		super(props)
		window.dataLayer = window.dataLayer || []
		googleSdk().then(val => {
			this.props.actions.hasLibraryLoad('google', val)
		}).catch(() => null)
		gtmSdk().then(() => {})
		awsSdk().then(() => {})
		chartJS().then(() => {})
		cseLibrary().then(() => {})
		mixpanel.init()
		chameleon.init()
		canny.init()
		window.addEventListener(
			'resize',
			() => {
				this.props.actions.windowResize(window.innerWidth, window.innerHeight)
			}
		)
		this.props.actions.appInitialize(
			window.innerWidth,
			window.innerHeight,
			platform,
			window.top !== window.self
		)
		googleApiInitializer()
	}

	componentDidMount() {
		if (!disabledFacebookLocations.includes(this.props.location.pathname)) {
			facebookPixelSdk().then(() => {})
			facebookSdk().then(val => {
				this.props.actions.hasLibraryLoad('facebook', val)
			})
		}
		// This function is only for store the oc parameter and utm_source parameter in the cookie,
		// please do not use the cookie for store data if it is not necessary
		storeURLParametersToCookie(this.props.location)
	}

	componentDidUpdate(prevProps) {
		// This function is only for store the oc parameter and utm_source parameter in the cookie,
		// please do not use the cookie for store data if it is not necessary
		if (this.props.location !== prevProps.location) {
			storeURLParametersToCookie(this.props.location)
		}
	}

	render() {
		return (
			<div>
				<Switch>
					<Route path={'/signup'} component={SignUpBase} />
					<Route path={'/login'} component={LogInTeacher} />
					<Route path={'/forgot_password'} component={ForgotPassword} />
					<Route path={'/new_password'} component={NewPassword} />
					<Route path={'/new_terms_and_conditions'} component={TermsAndConditionsRoute} />
					<Route path={'/verify-account'} component={VerifyAccount} />
					<Route path={'/student'} component={StudentJoinRoute} />
					<Route path={'/playground'} component={Playground} />
					<Route path={'/not_found'} component={NotFound} />
					<Route path={'/binders'} component={BindersBase} />
					<Route path={'/welcome/:step?'} component={Onboarding} />
					<Route path={'/admin'} component={AdminBase} />
					<Route path={'/libraries'} component={LibrariesBase} />
					<Route path={'/account'} component={AccountBase} />
					<Route path={'/school-trial/:userRole/:step'} component={AdminOnboarding} />
					<Route path={'/school-trial/share-teachers'} component={ShareTeachers} />
					<Route path={'/school-trial/refer-contact'} component={ReferContactNotification} />
					<Route path={'/public-library'} component={StoreFrontBase} />
					<Route path={'/quiz/create/:quizUID'} component={QuizCreationToolRoute} />
					<Route path={'/quiz/create'} component={QuizCreationToolRoute} />
					<Route path={'/quiz/screenshot/:quizUID'} component={QuizScreenshot} />
					<Route path={'/draw-it/create/:drawItUID'} component={DrawItCreationToolRoute} />
					<Route path={'/library/my-activities'} component={MyActivitiesRoute} />
					<Route path={'/library/preview/:entityID?'} component={MyLibraryPreviewRoute} />
					<Route path={'/library/:folderUID?'} component={MyLibraryRoute} />
					<Route path={'/lti/display'} component={LtiDisplayRoute} />
					<Route path={'/poll/create/:pollUID'} component={PollCreationToolRoute} />
					<Route path={'/poll/screenshot/:pollUID'} component={PollScreenshot} />
					<Route path={'/oeq/create/:oeqUID'} component={OEQCreationToolRoute} />
					<Route path={'/oeq/screenshot/:oeqUID'} component={OEQScreenshot} />
					<Route path={'/onedrive'} />
					<Route path={'/matching-pairs/create/:mpUID'} component={MatchingPairsCreationTool} />
					<Route path={'/matching-pairs/screenshot/:mpUID'} component={MatchingPairsScreenshot} />
					<Route path={'/store'} component={StoreBase} />
					<Route path={'/s'} component={StoreBaseNewRoute} />
					<Route path={'/t'} component={StoreBaseOldRoute} />
					<Route path={'/onedrive/'} />
					<Route path={'/desmos/create/:desmosUID'} component={DesmosCreationToolRoute} />
					<Route path={'/interactive-video/create/:interactiveVideoUID'} component={InteractiveVideoCreationToolRoutes} />
					<Route path={'/interactive-video/select/:interactiveVideoUID'} component={InteractiveVideoSelectRoute} />
					<Route path={'/media/screenshot/:mediaUid'} component={InteractiveVideoScreenshot} />
					<Route path={'/sso-successful-login/'} component={SSOSuccessRoute}/>
					<Route path={'/dm-storage/refer-contact'} component={DMStorageExperimentReferContactNotification} />
					<Route path={'/game/create/:gameUID'} component={GameCreationToolRoute} />
					<Route path={'/game/screenshot/:gameUID'} component={GameScreenshotRoute} />
					<Route path={'/google-slides'} component={GoogleSlidesRoutes} />
					<Route path={'/flocabulary-slide/builder/:flocabularyUID'} component={FlocabularyCreationToolRoute} />
					<Route path={'/flocabulary-slide/screenshot/:flocabularyUID'} component={FlocabularyScreenshot} />
					<Route path={'/flocabulary-slide/student/:flocabularyUID'} component={FlocabularySessionRoute} />
					<Route path={'/flocabulary-slide/teacher/:flocabularyUID'} component={FlocabularySessionRoute} />
					<Route path={'/flipgrid/builder/:flipgridUID'} component={FlipgridCreationToolRoute} />
					<Route path={'/connectors'} component={ConnectorRoutes} />
					<Route path={'/standalone/oeq/create/:oeqUID'} component={OEQStandaloneRoute} />
					<Route path={'/standalone/draw_it/create/:drawItUID'} component={DrawItStandaloneRoute} />
					<Route path={'/standalone/quiz/create/:quizUID'} component={QuizStandaloneRoute} />
					<Route path={'/standalone/poll/create/:pollUID'} component={PollStandaloneRoute} />
					<Route path={'/standalone/game/create/:gameUID'} component={GameStandaloneRoute} />
					<Route path={'/standalone/flipgrid/builder/:flipgridUID'} component={FlipgridStandaloneRoute} />
					<Route path={'/standalone/matching-pairs/create/:mpUID'} component={MatchingPairsStandalone} />
					<Route path={'/standalone/flocabulary-slide/builder/:flocabularyUID'} component={FlocabularyCreationToolStandaloneRoute} />
					<Route path={'/standalone/desmos/create/:desmosUID'} component={DesmosCreationToolStandaloneRoute} />
					<Route path={'/standalone/video/create/:videoUID'} component={VideoStandaloneRoute} />
					<Route path={'/quick-launch'} component={QuickLaunchRoutes} />
					<Route path={'/onboarding'} component={OnboardingActivityBase} />
					<Route path={'/interactive-video/:uid/preview'} component={InteractiveVideoPreviewRoute} />
					<Route path={'/session/interactive-video/:uid'} component={InteractiveVideoSessionRoute} />
					<Route path={'/session/fill-in-the-blanks/'} component={FillInTheBlanksSessionRoute} />
					<Route path={'/not-supported'} component={DeviceNotSupported} />
					<Route path={'/cookie-error'} component={CookiesNotSupported} />
					<Route path={'/google-slides-addon-error'} component={GoogleSlidesAddOnNotSupportedRoute} />
					<Route path={'/video/create/:videoUID'} component={VideoCreationToolRoutes} />
					<Route path={'/school-profile'} component={UserSchoolProfileRoute} />
					<Route path={'/external-activity/'} component={ExternalActivityRoute} />
					<Route path={'/session-preview/:puid/:sid/:pincode?'} component={SessionPreviewRoute} />
					<Redirect to="/not_found" />
				</Switch>
				<ModalsController />
				<LoadingLayer />
				<OverlaysController />
				<AlertsController />
				<ConfirmsController />
				<CenterInformationsController />
				<TopInformationsController />
				<IntercomIO />
			</div>
		)
	}
}

App.propTypes = {
	actions: PropTypes.object,
	children: PropTypes.element,
	dispatch: PropTypes.func,
	location: PropTypes.object,
}

function mapStateToProps(state) {
	return state
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		hasLibraryLoad: generalActions.hasLibraryLoad,
		windowResize: generalActions.windowResize,
		appInitialize: generalActions.appInitialize,
	}, dispatch)
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))
